import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { IAddressApi } from "./base/addressApi";
import { AddressByCompanyBuyerRequest, AddressRequest } from "../models/request";
import { AddressByBodyshopResponse, AddressResponse } from "../models/response";
import { Result } from "../models/common/resultResponse";
import { KeyValue } from "../models/common";

const baseRoute: string = "Address";

export class AddressApi extends IAddressApi {
	getAddressBodyshop(request: AddressRequest): Promise<AxiosResponse<Result<AddressResponse[]>>> {
		return api.get(`${baseRoute}/addressbodyshop`, { params: request });
	}

	getAddressByBodyshop(request: AddressRequest): Promise<AxiosResponse<Result<AddressByBodyshopResponse[]>>> {
		return api.get(`${baseRoute}/getbyguidbodyshop`, { params: request });
	}

	getBillingAddressSummary(
		request: AddressByCompanyBuyerRequest,
	): Promise<AxiosResponse<Result<AddressByBodyshopResponse[]>>> {
		return api.get(`${baseRoute}/getbillingaddress`, { params: request });
	}
	getDomain(request: AddressByCompanyBuyerRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`, { params: request });
	}
}
